export const CREDIT_BANK_DECISION_MADE = 'CREDIT_BANK_DECISION_MADE';

export const creditBankDecisionMade = payload => dispatch =>
  dispatch({
    type: CREDIT_BANK_DECISION_MADE,
    payload,
  });
